import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Participante } from '../Models/participante.model';
import { RespostaWebAPI } from '../Models/resposta-web-api.model';
import { UserToken } from '../Models/token.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Sugestao } from 'src/app/Models/sugestao.model';

@Injectable()
export class SugestaoService {

    token: UserToken;
    private sugestao = new Sugestao();
    private domParser: DOMParser;

    constructor(private router: Router, private http: HttpClient) {
        this.domParser = new DOMParser();
    }

    post(model: Sugestao): Observable<any> {
        const body = JSON.stringify(model);
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'  });
        return this.http.post(`${environment.apiUrl}sugestao`, body, { headers: headers });
    }

    put(model: Sugestao): Observable<any> {
        const body = JSON.stringify(model);
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'  });
        return this.http.put(`${environment.apiUrl}sugestao`, body, { headers: headers });
    }

    get(id: number): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'  });
        return this.http.get<any>(`${environment.apiUrl}sugestao?id=${id}`, { headers: headers });
    }

    getByAreaParticipante(areaparticipacaoid: number, participanteid: number): Observable<RespostaWebAPI> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'  });
        return this.http.get<RespostaWebAPI>(`${environment.apiUrl}sugestao?areaparticipacaoid=${areaparticipacaoid}&participanteid=${participanteid}`, { headers: headers });
    }
}